// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
	position: relative;
	overflow: hidden;
}
.button::before {
	content: "";
	position: absolute;
	top: 0;
	left: -150%; /* Start from the left */
	width: 100%; /* Full width */
	height: 100%; /* Full height */
	background: linear-gradient(
		120deg,
		transparent 0%,
		transparent 20%,
		rgba(250, 219, 219, 0.7) 70%,

		transparent 100%
	);

	animation: shimmer 3s infinite;
	border-radius: 5px;
}

@keyframes shimmer {
	0% {
		left: -250%;
		opacity: 0;
	}

	50% {
		left: 100%;
		opacity: 1;
	}

	100% {
		left: 350%;
		opacity: 0;
	}
}
.my-navbar {
	position: fixed;
	z-index: 10;
	width: 100vw;
	background-color: white;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	box-shadow: 0px 0px 6px 0px black;
	padding: 8px 10px 8px 8px;
	align-content: center;
	flex-wrap: wrap;
	z-index: 3003;
}

.logo-div {
}
.logo-div img {
	width: 120px;
	height: 36px;
}
.navbar-links {
	display: flex;
	align-items: flex-end;
	padding: 2px;
}
.navbar-links a {
	padding: 0.5rem 1.5rem 0.4rem 1.5rem;
	background: white;
	font-family: Inter-Bold, sens-serif;
	font-weight: 700;
	font-size: 1.4rem;
	text-decoration: none;
	color: var(--primary-color1);
	text-align: center;
}
.navbar-links a.button {
	background: linear-gradient(
		90deg,
		rgba(242, 124, 42, 1) 0%,
		rgba(231, 84, 37, 1) 50%,
		rgba(231, 84, 37, 1) 100%
	);
	color: white;
	border-radius: 2rem;
	padding: 0.5rem 1.5rem;
	margin-left: 0.5rem;
	align-self: center;
}
.navbar-links a.button.disabled {
	background: linear-gradient(
		90deg,
		hsl(0, 0%, 58%) 0%,
		rgb(100, 100, 100) 50%,
		rgb(90, 90, 90) 100%
	);
	pointer-events: none;
	cursor: default;
}
.navbar-links a.button span {
	padding: 0.5rem 0rem;
	width: 1.5rem;
}

.navbar-links a.button:hover,
.navbar-links a.button.selected {
	background: linear-gradient(
		90deg,
		var(--secondary-color2) 0%,
		var(--secondary-color1) 50%,
		var(--primary-color1) 100%
	);
	color: white;
}

.navbar-links a:hover,
.navbar-links a.selected {
	color: var(--primary-color2);
}

@media (min-width: 500px) {
}
`, "",{"version":3,"sources":["webpack://./src/components/NavBar/DesktopNav/MyNavbar.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,WAAW,EAAE,wBAAwB;CACrC,WAAW,EAAE,eAAe;CAC5B,YAAY,EAAE,gBAAgB;CAC9B;;;;;;;EAOC;;CAED,8BAA8B;CAC9B,kBAAkB;AACnB;;AAEA;CACC;EACC,WAAW;EACX,UAAU;CACX;;CAEA;EACC,UAAU;EACV,UAAU;CACX;;CAEA;EACC,UAAU;EACV,UAAU;CACX;AACD;AACA;CACC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,8BAA8B;CAC9B,iCAAiC;CACjC,yBAAyB;CACzB,qBAAqB;CACrB,eAAe;CACf,aAAa;AACd;;AAEA;AACA;AACA;CACC,YAAY;CACZ,YAAY;AACb;AACA;CACC,aAAa;CACb,qBAAqB;CACrB,YAAY;AACb;AACA;CACC,oCAAoC;CACpC,iBAAiB;CACjB,mCAAmC;CACnC,gBAAgB;CAChB,iBAAiB;CACjB,qBAAqB;CACrB,4BAA4B;CAC5B,kBAAkB;AACnB;AACA;CACC;;;;;EAKC;CACD,YAAY;CACZ,mBAAmB;CACnB,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC;;;;;EAKC;CACD,oBAAoB;CACpB,eAAe;AAChB;AACA;CACC,oBAAoB;CACpB,aAAa;AACd;;AAEA;;CAEC;;;;;EAKC;CACD,YAAY;AACb;;AAEA;;CAEC,4BAA4B;AAC7B;;AAEA;AACA","sourcesContent":[".button {\n\tposition: relative;\n\toverflow: hidden;\n}\n.button::before {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: 0;\n\tleft: -150%; /* Start from the left */\n\twidth: 100%; /* Full width */\n\theight: 100%; /* Full height */\n\tbackground: linear-gradient(\n\t\t120deg,\n\t\ttransparent 0%,\n\t\ttransparent 20%,\n\t\trgba(250, 219, 219, 0.7) 70%,\n\n\t\ttransparent 100%\n\t);\n\n\tanimation: shimmer 3s infinite;\n\tborder-radius: 5px;\n}\n\n@keyframes shimmer {\n\t0% {\n\t\tleft: -250%;\n\t\topacity: 0;\n\t}\n\n\t50% {\n\t\tleft: 100%;\n\t\topacity: 1;\n\t}\n\n\t100% {\n\t\tleft: 350%;\n\t\topacity: 0;\n\t}\n}\n.my-navbar {\n\tposition: fixed;\n\tz-index: 10;\n\twidth: 100vw;\n\tbackground-color: white;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbox-shadow: 0px 0px 6px 0px black;\n\tpadding: 8px 10px 8px 8px;\n\talign-content: center;\n\tflex-wrap: wrap;\n\tz-index: 3003;\n}\n\n.logo-div {\n}\n.logo-div img {\n\twidth: 120px;\n\theight: 36px;\n}\n.navbar-links {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tpadding: 2px;\n}\n.navbar-links a {\n\tpadding: 0.5rem 1.5rem 0.4rem 1.5rem;\n\tbackground: white;\n\tfont-family: Inter-Bold, sens-serif;\n\tfont-weight: 700;\n\tfont-size: 1.4rem;\n\ttext-decoration: none;\n\tcolor: var(--primary-color1);\n\ttext-align: center;\n}\n.navbar-links a.button {\n\tbackground: linear-gradient(\n\t\t90deg,\n\t\trgba(242, 124, 42, 1) 0%,\n\t\trgba(231, 84, 37, 1) 50%,\n\t\trgba(231, 84, 37, 1) 100%\n\t);\n\tcolor: white;\n\tborder-radius: 2rem;\n\tpadding: 0.5rem 1.5rem;\n\tmargin-left: 0.5rem;\n\talign-self: center;\n}\n.navbar-links a.button.disabled {\n\tbackground: linear-gradient(\n\t\t90deg,\n\t\thsl(0, 0%, 58%) 0%,\n\t\trgb(100, 100, 100) 50%,\n\t\trgb(90, 90, 90) 100%\n\t);\n\tpointer-events: none;\n\tcursor: default;\n}\n.navbar-links a.button span {\n\tpadding: 0.5rem 0rem;\n\twidth: 1.5rem;\n}\n\n.navbar-links a.button:hover,\n.navbar-links a.button.selected {\n\tbackground: linear-gradient(\n\t\t90deg,\n\t\tvar(--secondary-color2) 0%,\n\t\tvar(--secondary-color1) 50%,\n\t\tvar(--primary-color1) 100%\n\t);\n\tcolor: white;\n}\n\n.navbar-links a:hover,\n.navbar-links a.selected {\n\tcolor: var(--primary-color2);\n}\n\n@media (min-width: 500px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
